import { ULID } from '.';

export interface Payment {
	readonly id?: ULID;
	type: PaymentType;
	sepaDebit?: {
		iban: string;
	};
	card?: {
		number: number;
		cvc: number;
		experationMonth: number;
		experationYear: number;
	};
	isDefault: boolean;
	billingDetails: {
		name: string;
	};
	action: PaymentAction;
}

export interface PaymentAction {
	readonly id?: ULID;
	readonly customerID?: ULID;
	readonly paymentMethodID?: ULID;
	status: string;
	type: string;

	actionRedirect?: {
		readonly id?: ULID;
		readonly customerID?: ULID;
		readonly paymentMethodID?: ULID;
		readonly paymentMethodActionID?: ULID;
		url: string;
	};
}

export interface PaymentForm {
	customerId: ULID;
	stripeId: string;
	type: PaymentType;
	additionalInformation: {
		card?: PaymentFormCard;
		sepaDebit?: PaymentFormSEPA;
	};
	isDefault: boolean;
	billingDetails: {
		name: string;
		email: string;
	};
}

export interface PaymentFormEdit {
	id: ULID;
	customerId: ULID;
	type: PaymentType;
	isDefault: boolean;
	billingDetails: {
		name: string;
	};
}

export interface PaymentFormCard {
	last4?: string;
	experationMonth?: number;
	experationYear?: number;
}

export interface PaymentFormSEPA {
	last4?: string | null;
	bankCode?: string | null;
	country?: string | null;
}

export enum PaymentType {
	SEPA = 'sepa_debit',
	CARD = 'card',
	IDEAL = 'ideal',
	NONE = ''
}
